<template>
  <v-dialog max-width="500px" v-model="inDialog" @click:outside="onClickOutside" persistent>
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
                $t(formCreateName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('AccountID')"
                  v-model.trim="item.accountId"
                  name="accountId"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('accountId')"
                  :data-vv-as="$t('AccountID')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Số điện thoại')"
                  v-model.trim="item.phoneNumber"
                  name="phoneNumber"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('phoneNumber')"
                  :data-vv-as="$t('Số điện thoại')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-select
                  :items="classs"
                  :label="$t('Tên lớp')"
                  v-model="item.classId"
                  name="classId"
                  item-value="classId"
                  item-text="className"
                  :data-vv-as="$t('Level')"
                  :error-messages="errors.first('classId')"
                  disabled
                  v-on:change="levelChange(item.classId)"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Họ tên')"
                  v-model.trim="item.accountName"
                  name="accountName"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('accountName')"
                  :data-vv-as="$t('Họ tên')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Năm sinh')"
                  v-model.trim="item.birthYear"
                  name="birthYear"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('birthYear')"
                  :data-vv-as="$t('Năm sinh')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                  type="text"
                  :label="$t('Zalo phụ huynh')"
                  v-model.trim="item.zaloPH"
                  name="zaloPH"
                  v-validate="'required'"
                  maxLength="250"
                  :error-messages="errors.first('zaloPH')"
                  :data-vv-as="$t('Zalo phụ huynh')"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-form>
      <div style="text-align: right">
        <v-btn color="primary" @click="onSave">
          <v-icon dark left>save</v-icon>
          {{ $t("lang.common.save") }}
        </v-btn>
        <v-btn color="error" @click="onCancel">
          <v-icon dark left>cancel</v-icon>
          {{ $t("lang.common.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import {message} from "../../../services";
import axios from "axios";
import {areaContants} from "@/constants";
import moment from "moment/moment";

export default {
  name: "material-type-group-create",
  components: {message, axios},
  props: {
    propsItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    cDialog: {
      type: Boolean,
      default: false,
    },
    formCreateName: {
      type: String,
      default: '',
    },
    units: {
      type: Array,
      default: [],
    },

    classs: {
      type: Array,
      default: [],
    },

  },
  data: () => {
    return {
      areaStatus: areaContants.areaStatus,
      item: {
        accountId: "",
        phoneNumber: "",
        accountName: "",
        birthYear: "",
        zaloPH: ""
      },
      inDialog: false,
    };
  },
  watch: {
    propsItem: {
      handler(value) {
        console.log(value);
        if (value !== null) {
          this.item = {
            id: value.id,
            accountId: value.accountId
                ? value.accountId
                : "",
            phoneNumber: value.phoneNumber
                ? value.phoneNumber
                : "",
            accountName: value.accountName
                ? value.accountName
                : "",
            classId: this.$route.params.id,
            birthYear: value.birthYear
                ? value.birthYear
                : "",
            zaloPH: value.zaloPH
                ? value.zaloPH
                : "",
            status: value.status ? value.status : 0,
          };
        } else {
          this.resetFrom();
        }
      },
      deep: true,
    },
    cDialog(value) {
      this.inDialog = value;
    },
    inDialog(value) {
      if (!value) {
        this.$emit("closeCreateDialog", "");
      }
    },
  },
  methods: {
    resetFrom: function () {
      this.item = {
        accountId: "",
        phoneNumber: "",
        accountName: "",
        birthYear: "",
        zaloPH: ""
      };
    },
    checkMinDate(minDate = moment()) {
      if (minDate == '' || minDate == null) minDate = moment();
      let minDate_tmp = moment(String(minDate));
      let today = moment();
      // if (minDate_tmp <= today) {
      //     minDate = moment().format('YYYY-MM-DD');
      // } else {
      minDate = minDate_tmp.format('YYYY-MM-DD');
      // }
      return minDate;
    },
    clearDropDate() {
      this.item.startDate = '';
    },
    levelChange(levelId) {
      this.getNextCode();
    },
    getNextCode: function () {
      axios.post(
          process.env.VUE_APP_API_URL + "/babiLevel/listAllName", {status: 1}
      )
          .then((data) => {
            this.item = Object.assign({}, this.item, {"code": data})
          });
    },
    onCancel: function () {
      this.$emit("closeCreateDialog", "");
    },
    onSave: function () {
      // console.log(this.item);
      this.$validator.validate().then((valid) => {
        if (!valid) {
          message.error(this.$t("lang.common.validate_fail"));
          return;
        }
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/babiAccountClass/save",
                this.item
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.resetFrom();
                    this.onCancel();
                  } else {
                    let msg = data.description;
                    if (data.description === 'lang.category.duplicateCode') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    } else if (data.description === 'lang.category.duplicateName') {
                      msg = 'lang.materialTypeGroup.duplicateCode';
                    }
                    message.error(this.$t(msg));
                  }
                },
                (error) => {
                  console.log(error);
                }
            );
      });
    },

  },
  created() {
    // Program
    axios.post(
        process.env.VUE_APP_API_URL + "/babiClass/listAllName", {status: 1}
    )
        .then(
            (data) => {
              if (data.length > 0) {
                this.classs = data;
              }
            }
        );
  },
};
</script>
